/**
 * Module dependencies.
 */

import { AxiosInstance } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * `RegisterPayload` type.
 */

export type RegisterPayload = { email: string; name: string; password: string };

/**
 * Register.
 */

function register(client: AxiosInstance, payload: RegisterPayload): Promise<void> {
  return client.post(resolveAppUrl('register'), payload).then(({ data }) => data);
}

/**
 * `Options` type.
 */

type Options = UseMutationOptions<void, unknown, RegisterPayload, unknown>;

/**
 * Export `useRegister`.
 */

export function useRegister(options?: Options) {
  const client = useRequestProvider();

  return useMutation({
    mutationFn: async (payload: RegisterPayload) => {
      return await register(client, payload);
    },
    ...options
  });
}
